var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { useSelector } from "react-redux";
import di from "../../../di/serviceLocator";
export var ShowContacts = function (props) {
    var contactData = useSelector(function (state) { return state.Clients.ClientMultipleContact.reducersData.data; });
    var accessData = useSelector(function (state) { return state.Clients.ClientMCAccess.reducersData.data; });
    var AddContactColumn = [
        {
            columnName: "Type",
            key: "contactType",
        },
        {
            columnName: "Contact Number",
            key: "contactNo",
        },
        // {commented by dhiraj for view only
        //   columnName: "Action",
        //   keysForCustomFunction: ["contactNo", "contactType", "retypeContactNo","contactID"],
        //   tdCustomFunction: (keysForCustomFunction: Array<string>) => {
        //     console.log("retypeContactNo", keysForCustomFunction);
        //     return (
        //       <div className="d-flex">
        //         <div className="edit-delete">
        //           <EdButton
        //             btnTyp="midnight-blue"
        //             value={"Edit"}
        //             onClick={() => {
        //               props.setEditContact(true);
        //               props.setMobileNumber(keysForCustomFunction[0]);
        //               props?.setRetypeContactNo(keysForCustomFunction[2]);
        //               props.setContactType(keysForCustomFunction[1]);
        //               props?.setResetContact(false);
        //               props?.setContactId(keysForCustomFunction[3]);
        //               props?.setShowDeleteConfirmation(false);
        //             }}
        //             disabled={!accessData?.strContactLnk}
        //           />
        //           <span className="mgl-10">
        //             <EdButton
        //               btnTyp="midnight-blue-border"
        //               value={"Delete"}
        //               onClick={() => {
        //                 props.setEditContact(false);
        //                 props.setMobileNumber(keysForCustomFunction[0]);
        //                 props?.setRetypeContactNo(keysForCustomFunction[2]);
        //                 props.setContactType(keysForCustomFunction[1]);
        //                 props?.setResetContact(false);
        //                 props?.setContactId(keysForCustomFunction[3]);
        //                 if (confirm("are you sure want to the delete record?")) {
        //                   props?.setShowDeleteConfirmation(true);
        //                 }
        //               }}
        //               disabled={!accessData?.strContactLnk}
        //             />
        //           </span>
        //         </div>
        //       </div>
        //     );
        //   },
        //   columnClassName: "action",
        // },
    ];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _a = __read(React.useState(false), 2), disableAllButton = _a[0], setDisableAllButton = _a[1];
    React.useEffect(function () {
        if (selectedAccount && (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode)) {
            di.clients.getClientMCAccessData({
                acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
            });
            if (contactData && contactData.length >= 5) {
                setDisableAllButton(true);
            }
        }
    }, [selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-0 mx-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props === null || props === void 0 ? void 0 : props.setNewAddContact(false);
                            } }),
                        "View Contact"))),
            React.createElement(Row, { className: "new-add-contact" }),
            React.createElement(GenericTable, { columns: AddContactColumn, data: contactData, parentClassName: "salestableParentClass scrollbar-table add-contact-table", tableClassName: "salestableclass" }))));
};
